/**
 * CollectionFilters — barre de filtres par catégorie sur les pages de collection.
 * Filtrage en temps réel côté client, sans rechargement de page.
 */
(function () {
  'use strict';

  function CollectionFilters() {
    this.bar = document.getElementById('collection-filter-bar');
    this.grid = document.getElementById('collection-product-grid');
    this.emptyMessage = document.getElementById('collection-filter-empty');
    this.activeFilter = 'tous';
    if (this.bar && this.grid) {
      this.init();
    }
  }

  CollectionFilters.prototype.init = function () {
    this.buttons = Array.prototype.slice.call(this.bar.querySelectorAll('.filter-pill'));
    this.cards = Array.prototype.slice.call(this.grid.querySelectorAll('.product-card'));

    var self = this;
    this.buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        self.filterProducts(filter);
        self.updateActiveState(btn);
      });
    });

    window.addEventListener('resize', function () { self.handleResize(); });
    this.handleResize();
  };

  CollectionFilters.prototype.getProductTags = function (card) {
    var raw = card.getAttribute('data-tags') || '';
    return raw
      .split(',')
      .map(function (t) { return t.trim().toLowerCase(); })
      .filter(Boolean);
  };

  CollectionFilters.prototype.filterProducts = function (filter) {
    this.activeFilter = filter;
    var visibleCount = 0;

    this.cards.forEach(function (card) {
      var tags = this.getProductTags(card);
      var show = filter === 'tous' || tags.indexOf(filter) !== -1;
      card.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    }, this);

    if (this.emptyMessage) {
      this.emptyMessage.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    var pagination = document.querySelector('.pagination');
    if (pagination) {
      pagination.style.display = filter === 'tous' ? '' : 'none';
    }
  };

  CollectionFilters.prototype.updateActiveState = function (activeButton) {
    this.buttons.forEach(function (btn) { btn.classList.remove('is-active'); });
    activeButton.classList.add('is-active');
  };

  CollectionFilters.prototype.handleResize = function () {
    // Le défilement horizontal mobile est géré en CSS (overflow-x).
    // Point d'extension conservé pour d'éventuels ajustements futurs.
  };

  function initCollectionFilters() {
    new CollectionFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }
})();
